import { POSITION } from '@voltmoney/types';
import { ROUTE } from '../../../routes';
import { WIDGET, } from '@voltmoney/schema';
import { DigioKycStatus, ImportScriptSrc, LENDER_ID, VOLT_ERROR_CODE, } from '../../../configs/constants';
import { getDigio, isFromAndroidWebview, isMobile, nextStepCredStepper, } from '../../../configs/utils';
import { api } from '../../../configs/api';
import SharedPropsService from '../../../SharedPropsService';
import { APP_CONFIG, getAppHeader } from '../../../configs/config';
import { Platform } from 'react-native';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getParameters } from '../../../configs/uri-config-utils';
let pollInterval;
let responseFromDigio;
let currentStepId;
let hasNavigated = false;
export const AadharInitAction = async (action, _datastore, { instrumentTrack, navigate, setDatastore, importScript, network, digio, showPopup, appendWidgets, removeWidgets, }) => {
    instrumentTrack("PROCEED_WITH_DIGILOCKER_BUTTON_CLICKED");
    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
        loading: true,
    });
    const user = await SharedPropsService.getUser();
    const lenderId = user?.linkedApplications[0].lenderAccountId;
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
        failedCard: false,
        successCard: false
    });
    if (Platform.OS === 'web') {
        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
            failedCard: false,
            successCard: false,
            showInProgressCard: true
        });
        importScript(ImportScriptSrc.DIGIO_SCRIPT, await getDigio, async (digio_response) => {
            clearInterval(pollInterval);
            network
                .get(`${api.digioKycCheckRequestStatusOnCallBackV2}${applicationId}`, {
                headers: await getAppHeader(),
                handleFromMF: true
            })
                .then(async (response) => {
                if (response.status === 200) {
                    if (response.data.stepResponseObject ===
                        DigioKycStatus.COMPLETED) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                        currentStepId = response?.data?.updatedApplicationObj?.currentStepId;
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            successCard: true,
                            showInProgressCard: false,
                            successTitle: lenderId === 'Tata'
                                ? 'Aadhaar verified successfully'
                                : 'Aadhaar and PAN verified successfully',
                            successButtonTitle: "Continue"
                        });
                    }
                }
                else if (response?.response?.status === 400) {
                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                        loading: false,
                    });
                    if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.DIGIO_PAN_MISMATCH) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            failedCard: true,
                            failedTitle: "Verification failed!",
                            failedSubTitle: `${response?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it."
                        });
                        return;
                    }
                    else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PAN_AADHAAR_NOT_LINKED || response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PAN_NOT_SEEDED) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            failedCard: true,
                            failedTitle: "PAN is not linked with the provided Aadhaar",
                            failedSubTitle: `${response?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it."
                        });
                        return;
                    }
                    else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.INVALID_PAN) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            failedCard: true,
                            failedTitle: "PAN is invalid",
                            failedSubTitle: `${response?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it."
                        });
                        return;
                    }
                    else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.MISMATCH_DETECTED) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            failedCard: true,
                            failedTitle: "PAN is invalid",
                            failedSubTitle: `${response?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it."
                        });
                        return;
                    }
                    else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.AGE_BELOW_LIMIT) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            failedCard: true,
                            failedTitle: "Minimum age requirement not met",
                            failedSubTitle: `${response?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it."
                        });
                        return;
                    }
                    else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.AGE_ABOVE_LIMIT) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            failedCard: true,
                            failedTitle: "Age eligibility criteria not met",
                            failedSubTitle: `${response?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it."
                        });
                        return;
                    }
                    const failureJson = JSON.parse(response.response.data.message);
                    const errorCode = response.response.data.voltErrorCode;
                    if (failureJson.failureType === "NAME_MISMATCH") {
                        const heading = failureJson.nameMatchFailureDetails.description;
                        const key1 = failureJson.nameMatchFailureDetails.source.description;
                        const value1 = failureJson.nameMatchFailureDetails.source.value;
                        const key2 = failureJson.nameMatchFailureDetails.target.description;
                        const value2 = failureJson.nameMatchFailureDetails.target.value;
                        await navigate(ROUTE.NAME_MISMATCH, {
                            heading: heading,
                            key1: key1,
                            value1: value1,
                            key2: key2,
                            value2: value2,
                            isFromKYC: true,
                            voltErrorCode: errorCode
                        });
                    }
                }
            });
        }, async (response) => {
            clearInterval(pollInterval);
            if (response?.error_code === "CANCELLED") {
                setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                    failedCard: true,
                    failedTitle: "KYC canceled",
                    failedSubTitle: `Your KYC is canceled`,
                    failedButtonTitle: "Ok, got it.",
                });
            }
            else {
                network
                    .get(`${api.digioKycCheckRequestStatusOnCallBackV2}${applicationId}`, {
                    headers: await getAppHeader(),
                    handleFromMF: true
                })
                    .then(async (response) => {
                    if (response.status === 200) {
                        if (response.data.stepResponseObject ===
                            DigioKycStatus.COMPLETED) {
                            await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                loading: false,
                            });
                            currentStepId = response?.data?.updatedApplicationObj?.currentStepId;
                            await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                successCard: true,
                                successTitle: lenderId === 'Tata'
                                    ? 'Aadhaar verified successfully'
                                    : 'Aadhaar and PAN verified successfully',
                                successButtonTitle: "Continue"
                            });
                        }
                    }
                    else if (response?.response?.status === 400) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                        if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.DIGIO_PAN_MISMATCH) {
                            await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                failedCard: true,
                                failedTitle: "Verification failed!",
                                failedSubTitle: `${response?.response?.data?.message}`,
                                failedButtonTitle: "Ok, got it."
                            });
                            return;
                        }
                        else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PAN_AADHAAR_NOT_LINKED || response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PAN_NOT_SEEDED) {
                            await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                failedCard: true,
                                failedTitle: "PAN is not linked with the provided Aadhaar",
                                failedSubTitle: `${response?.response?.data?.message}`,
                                failedButtonTitle: "Ok, got it."
                            });
                            return;
                        }
                        else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.INVALID_PAN) {
                            await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                failedCard: true,
                                failedTitle: "PAN is invalid",
                                failedSubTitle: `${response?.response?.data?.message}`,
                                failedButtonTitle: "Ok, got it."
                            });
                            return;
                        }
                        const failureJson = JSON.parse(response.response.data.message);
                        const errorCode = response.response.data.voltErrorCode;
                        if (failureJson.failureType === "NAME_MISMATCH") {
                            const heading = failureJson.nameMatchFailureDetails.description;
                            const key1 = failureJson.nameMatchFailureDetails.source.description;
                            const value1 = failureJson.nameMatchFailureDetails.source.value;
                            const key2 = failureJson.nameMatchFailureDetails.target.description;
                            const value2 = failureJson.nameMatchFailureDetails.target.value;
                            await navigate(ROUTE.NAME_MISMATCH, {
                                heading: heading,
                                key1: key1,
                                value1: value1,
                                key2: key2,
                                value2: value2,
                                isFromKYC: true,
                                voltErrorCode: errorCode
                            });
                        }
                    }
                });
            }
        });
    }
    // Digio Kyc Mandate
    await network
        .get(`${api.digioKycInitiateRequestV2}${applicationId}`, {
        headers: await getAppHeader(),
    })
        .then(response => {
        setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
            loading: true,
        });
        if (response.status === 200) {
            if (response.data && response.data.stepResponseObject) {
                const requestId = response.data.stepResponseObject.requestId;
                const tokenId = response.data.stepResponseObject.tokenId;
                if (Platform.OS !== 'web') {
                    const requestId = response.data.stepResponseObject.requestId;
                    const tokenId = response.data.stepResponseObject.tokenId;
                    const identifier = lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? response.data.stepResponseObject.identifier : user.user.phoneNumber;
                    navigate(ROUTE.DIGIO_MODAL, {
                        requestId: requestId,
                        tokenId: tokenId,
                        identifier: identifier
                    });
                    removeWidgets(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, [
                        { id: 'title', type: WIDGET.TEXT },
                        { id: 'spaceSubTitle', type: WIDGET.SPACE },
                        { id: 'subTitle', type: WIDGET.STACK },
                        {
                            id: 'spaceSecondarySubTitle',
                            type: WIDGET.SPACE,
                        },
                        { id: 'informationCard', type: WIDGET.STACK },
                        {
                            id: 'stackBottom',
                            type: WIDGET.STACK,
                            position: POSITION.ABSOLUTE_BOTTOM,
                        },
                    ]);
                }
                else {
                    const identifier = lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() ? response.data.stepResponseObject.identifier : user.user.phoneNumber;
                    // Take the Digio initialisation on the UI thread
                    setTimeout(() => {
                        digio.init();
                        digio.submit(requestId, identifier, tokenId);
                    });
                    //polling
                    pollInterval = setInterval(async () => {
                        network
                            .get(`${api.digioKycCheckRequestStatusV2}${applicationId}`, {
                            headers: await getAppHeader(),
                            handleFromMF: true
                        }, async () => {
                            return;
                        }, {
                            disableDefault: true
                        })
                            .then(async (res) => {
                            if (response.status === 200) {
                                if (response.data.stepResponseObject ===
                                    DigioKycStatus.COMPLETED) {
                                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                        loading: false,
                                    });
                                    currentStepId = response?.data?.updatedApplicationObj?.currentStepId;
                                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                        successCard: true,
                                        showInProgressCard: false,
                                        successTitle: lenderId === 'Tata'
                                            ? 'Aadhaar verified successfully'
                                            : 'Aadhaar and PAN verified successfully',
                                        successButtonTitle: "Continue"
                                    });
                                }
                            }
                            else if (response?.response?.status === 400) {
                                await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                    loading: false,
                                });
                                if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.DIGIO_PAN_MISMATCH) {
                                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                        failedCard: true,
                                        failedTitle: "Verification failed!",
                                        failedSubTitle: `${response?.response?.data?.message}`,
                                        failedButtonTitle: "Ok, got it."
                                    });
                                    return;
                                }
                                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PAN_AADHAAR_NOT_LINKED || response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.PAN_NOT_SEEDED) {
                                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                        failedCard: true,
                                        failedTitle: "PAN is not linked with the provided Aadhaar",
                                        failedSubTitle: `${response?.response?.data?.message}`,
                                        failedButtonTitle: "Ok, got it."
                                    });
                                    return;
                                }
                                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.INVALID_PAN) {
                                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                        failedCard: true,
                                        failedTitle: "PAN is invalid",
                                        failedSubTitle: `${response?.response?.data?.message}`,
                                        failedButtonTitle: "Ok, got it."
                                    });
                                    return;
                                }
                                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.MISMATCH_DETECTED) {
                                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                        failedCard: true,
                                        failedTitle: "PAN is invalid",
                                        failedSubTitle: `${response?.response?.data?.message}`,
                                        failedButtonTitle: "Ok, got it."
                                    });
                                    return;
                                }
                                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.AGE_BELOW_LIMIT) {
                                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                        failedCard: true,
                                        failedTitle: "Minimum age requirement not met",
                                        failedSubTitle: `${response?.response?.data?.message}`,
                                        failedButtonTitle: "Ok, got it."
                                    });
                                    return;
                                }
                                else if (response?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.AGE_ABOVE_LIMIT) {
                                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                                        failedCard: true,
                                        failedTitle: "Age eligibility criteria not met",
                                        failedSubTitle: `${response?.response?.data?.message}`,
                                        failedButtonTitle: "Ok, got it."
                                    });
                                    return;
                                }
                                const failureJson = JSON.parse(response.response.data.message);
                                const errorCode = response.response.data.voltErrorCode;
                                if (failureJson.failureType === "NAME_MISMATCH") {
                                    const heading = failureJson.nameMatchFailureDetails.description;
                                    const key1 = failureJson.nameMatchFailureDetails.source.description;
                                    const value1 = failureJson.nameMatchFailureDetails.source.value;
                                    const key2 = failureJson.nameMatchFailureDetails.target.description;
                                    const value2 = failureJson.nameMatchFailureDetails.target.value;
                                    await navigate(ROUTE.NAME_MISMATCH, {
                                        heading: heading,
                                        key1: key1,
                                        value1: value1,
                                        key2: key2,
                                        value2: value2,
                                        isFromKYC: true,
                                        voltErrorCode: errorCode
                                    });
                                }
                            }
                            else {
                            }
                        });
                    }, APP_CONFIG.POLLING_INTERVAL);
                }
            }
        }
    })
        .catch(error => {
        console.log(error);
    });
};
export const digioCallback = async (action, datastore, { network, setDatastore }) => {
    responseFromDigio = action.payload;
    const type = action.payload.type;
    const error = action.payload.error;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") :
        userContextResponse.data.linkedApplications[0].applicationId;
    await network
        .get(`${api.digioKycCheckRequestStatusOnCallBackV2}${applicationId}`, {
        headers: await getAppHeader(),
    })
        .then(async (response) => {
    });
};
export const GoBackAction = async (action, _datastore, { navigateToBase, removeWidgets, setDatastore }) => {
    await navigateToBase(ROUTE.KYC_STEPPER);
};
export const failedVerification = async (action, _datastore, { setDatastore, hidePopup }) => {
    setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
        failedCard: false,
        showInProgressCard: false
    });
    console.warn('*** failedVerification action triggered ***');
};
export const successVerification = async (action, _datastore, { setDatastore, navigateToBase }) => {
    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
        successCard: false
    });
    const cStepId = action?.payload?.currentStepId;
    const stepId = cStepId ? cStepId : currentStepId;
    const routeObj = await nextStepCredStepper(stepId);
    await navigateToBase(routeObj.routeId, routeObj.params);
};
export const digilockerAction = async (action, _datastore, { instrumentTrack, navigate }) => {
    instrumentTrack("UPLOAD_KYC_DOCUMENT_BUTTON_CLICKED");
    await navigate(ROUTE.KYC_DOCUMENTS_UPLOAD_BASE, {});
};
export const BajajAadharInitAction = async (action, _datastore, { instrumentTrack, setDatastore, network, removeWidgets, navigateWithClear, navigate }) => {
    instrumentTrack("PROCEED_WITH_DIGILOCKER_BUTTON_CLICKED");
    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
        loading: true,
    });
    if (Platform.OS === "web" && !isMobile()) {
        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
            showInProgressCard: true,
            failedCard: false,
            successCard: false,
            showAddressMismatchCard: false,
            counter: Math.random()
        });
    }
    else {
        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
            showInProgressCard: false,
            failedCard: false,
            successCard: false,
            counter: Math.random()
        });
    }
    const user = await SharedPropsService.getUser();
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    let bajajDigioWindowObj;
    let pollInterval;
    // Digio Kyc Mandate
    const bajajDigioInitResponse = await network.get(`${api.bajajDigioInit}${applicationId}`, {
        headers: await getAppHeader()
    });
    if (bajajDigioInitResponse && bajajDigioInitResponse.status === 200) {
        const requestUrl = bajajDigioInitResponse?.data?.stepResponseObject?.requestUrl;
        let isFromRnSDk;
        let isFromiOSSDK;
        if (Platform.OS === "web") {
            const params = getParameters(window.location.href);
            isFromRnSDk = params?.isFromRnSdk;
            isFromiOSSDK = params?.isFromiOSSdk;
        }
        //handle for web
        if (Platform.OS === 'web' && requestUrl) {
            if (isFromRnSDk || isFromiOSSDK) {
                if (isFromiOSSDK) {
                    // @ts-ignore
                    window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage(requestUrl);
                }
                else {
                    bajajDigioWindowObj = window.open(requestUrl, '_parent', 'width=800,height=600');
                    console.warn("URL RECEIVED IN THE SDK", requestUrl);
                }
            }
            else {
                console.warn("URL RECEIVED IS", requestUrl);
                bajajDigioWindowObj = window.open(requestUrl, 'PopupWindowName', 'width=800,height=600');
            }
        }
        else if (Platform.OS !== 'web') {
            navigate(ROUTE.DIGIO_MODAL, {
                showKycPod: true,
                webUrl: requestUrl
            });
            removeWidgets(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, [
                { id: 'title', type: WIDGET.TEXT },
                { id: 'spaceSubTitle', type: WIDGET.SPACE },
                { id: 'subTitle', type: WIDGET.STACK },
                {
                    id: 'spaceSecondarySubTitle',
                    type: WIDGET.SPACE,
                },
                { id: 'informationCard', type: WIDGET.STACK },
                {
                    id: 'stackBottom',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ]);
        }
        const checkDigioStatus = async () => {
            if (Platform.OS !== "web") {
                const digioStatusResponse = await network.get(`${api.bajajDigioDeepStatus}${applicationId}`, {
                    headers: await getAppHeader(),
                }, async () => {
                    return;
                }, { disableDefault: true });
                if (digioStatusResponse?.status === 200) {
                    const digioStatus = digioStatusResponse?.data?.stepResponseObject;
                    if (digioStatus === DigioKycStatus.COMPLETED) {
                        currentStepId = digioStatusResponse?.data?.updatedApplicationObj?.currentStepId;
                        instrumentTrack("KYC_DIGILOCKER_SUCCESS", {
                            "type": "Bajaj Digilocker",
                            "remark": digioStatusResponse?.message,
                            "kyc_status": digioStatus,
                            "status": "SUCCESS"
                        });
                        clearInterval(pollInterval);
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showSuccessModal: true,
                            showFailedModal: false,
                            successTitle: 'Aadhaar and PAN verified successfully',
                            successSubTitle: ' ',
                            successButtonTitle: 'Continue',
                            loading: true
                        });
                    }
                    else if (digioStatus === DigioKycStatus.EXPIRED
                        || digioStatus === DigioKycStatus.FAILED) {
                        clearInterval(pollInterval);
                        instrumentTrack("KYC_DIGILOCKER_SUCCESS", {
                            "type": "Bajaj Digilocker",
                            "remark": digioStatusResponse?.message,
                            "kyc_status": digioStatus,
                            "status": "FAILURE"
                        });
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: 'Something went wrong',
                            failedSubTitle: "",
                            failedButtonTitle: 'Try again',
                            loading: true
                        });
                    }
                }
                else {
                    clearInterval(pollInterval);
                    if (digioStatusResponse?.response?.data?.voltErrorCode === VOLT_ERROR_CODE.DIGIO_PAN_MISMATCH) {
                        instrumentTrack("KYC_DIGILOCKER_SUCCESS", {
                            "type": "Bajaj Digilocker",
                            "remark": digioStatusResponse?.message,
                            "kyc_status": "DIGIO_PAN_MISMATCH",
                            "status": "FAILURE"
                        });
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: 'PAN mismatch',
                            failedSubTitle: digioStatusResponse.response.data.message,
                            failedButtonTitle: 'Try again',
                            loading: true
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.ADDRESS_MISMATCH) {
                        bajajDigioWindowObj?.close();
                        clearInterval(pollInterval);
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showAddressMismatchCard: true,
                            showFailedModal: false,
                            showSuccessModal: false
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.AGE_BELOW_LIMIT) {
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: "Minimum age requirement not met",
                            failedSubTitle: `${digioStatusResponse?.response?.data?.message}`,
                            failedButtonTitle: 'Ok, got it.',
                            loading: true
                        });
                        return;
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.AGE_ABOVE_LIMIT) {
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: "Age eligibility criteria not met",
                            failedSubTitle: `${digioStatusResponse?.response?.data?.message}`,
                            failedButtonTitle: 'Ok, got it.',
                            loading: true
                        });
                        return;
                    }
                }
                await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                    loading: false,
                });
            }
            else if (Platform.OS === "web") {
                window.addEventListener('message', async function (event) {
                    if (event?.data === "stopLoader") {
                        clearInterval(pollInterval);
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            showAddressMismatchCard: false,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application",
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                    }
                    console.log('Message received from React Native (window):', event.data);
                    // Do something with the message
                });
                const digioStatusResponse = await network.get(`${api.bajajDigioDeepStatus}${applicationId}`, {
                    headers: await getAppHeader(),
                    handleFromMF: true
                });
                if (digioStatusResponse?.status === 200) {
                    const digioStatus = digioStatusResponse?.data?.stepResponseObject;
                    if (bajajDigioWindowObj?.closed && (digioStatus !== DigioKycStatus.COMPLETED && digioStatus !== DigioKycStatus.FAILED && digioStatus !== DigioKycStatus.EXPIRED)) {
                        bajajDigioWindowObj?.close();
                        clearInterval(pollInterval);
                        sendPostMessageToRnWebview();
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            showAddressMismatchCard: false,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application",
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                    }
                    else if (digioStatus === DigioKycStatus.COMPLETED) {
                        bajajDigioWindowObj?.close();
                        sendPostMessageToRnWebview();
                        clearInterval(pollInterval);
                        currentStepId = digioStatusResponse?.data?.updatedApplicationObj?.currentStepId;
                        instrumentTrack("KYC_DIGILOCKER_SUCCESS", {
                            "type": "Bajaj Digilocker",
                            "remark": digioStatusResponse?.message,
                            "kyc_status": digioStatus,
                            "status": "SUCCESS"
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: true,
                            failedCard: false,
                            showAddressMismatchCard: false,
                            successTitle: 'Aadhaar and PAN verified successfully',
                            successSubTitle: "",
                            successButtonTitle: 'Continue',
                            counter: Math.random()
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                    }
                    else if (digioStatus === DigioKycStatus.EXPIRED
                        || digioStatus === DigioKycStatus.FAILED) {
                        bajajDigioWindowObj?.close();
                        sendPostMessageToRnWebview();
                        clearInterval(pollInterval);
                        instrumentTrack("KYC_DIGILOCKER_SUCCESS", {
                            "type": "Bajaj Digilocker",
                            "remark": digioStatusResponse?.message,
                            "kyc_status": digioStatus,
                            "status": "FAILURE"
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            showAddressMismatchCard: false,
                            failedTitle: 'Something went wrong',
                            failedSubTitle: "",
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                    }
                }
                else {
                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                        loading: false
                    });
                    clearInterval(pollInterval);
                    bajajDigioWindowObj?.close();
                    if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.DIGIO_PAN_MISMATCH) {
                        sendPostMessageToRnWebview();
                        instrumentTrack("KYC_DIGILOCKER_SUCCESS", {
                            "type": "Bajaj Digilocker",
                            "remark": digioStatusResponse?.message,
                            "kyc_status": "DIGIO_PAN_MISMATCH",
                            "status": "FAILURE"
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            showAddressMismatchCard: false,
                            failedTitle: 'PAN mismatch',
                            failedSubTitle: digioStatusResponse.response.data.message,
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.ADDRESS_MISMATCH) {
                        sendPostMessageToRnWebview();
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            showAddressMismatchCard: true,
                            successCard: false,
                            failedCard: false,
                            counter: Math.random()
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.AGE_BELOW_LIMIT) {
                        sendPostMessageToRnWebview();
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            showAddressMismatchCard: false,
                            failedTitle: "Minimum age requirement not met",
                            failedSubTitle: `${digioStatusResponse?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it.",
                            counter: Math.random(),
                        });
                        return;
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.AGE_ABOVE_LIMIT) {
                        sendPostMessageToRnWebview();
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            showAddressMismatchCard: false,
                            failedTitle: "Age eligibility criteria not met",
                            failedSubTitle: `${digioStatusResponse?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it.",
                            counter: Math.random()
                        });
                        return;
                    }
                }
            }
        };
        pollInterval = setInterval(async () => {
            await checkDigioStatus();
        }, 3000);
    }
};
export const needHelpAction = async (action, datastore, { navigate }) => {
    let isFromTdl = false;
    if (Platform.OS === 'web') {
        let params = getParameters(window.location.href);
        if (params.platform === "TATADIGITAL" /* AppPlatform.TDL */) {
            isFromTdl = true;
        }
        if (isFromAndroidWebview() && isFromTdl) {
            window.open("FAQ_CLICKED", "_parent");
            //@ts-ignore
        }
        else {
            await navigate(ROUTE.CONTACT_US_CARD);
        }
        // @ts-ignore
        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("FAQ");
    }
    else {
        await navigate(ROUTE.CONTACT_US_CARD);
    }
};
const sendPostMessageToRnWebview = () => {
    if (Platform.OS === 'web') {
        const params = getParameters(window.location.href);
        const isFromRnSDk = params?.isFromRnSdk;
        if (Platform.OS === 'web')
            // Below code is used to send post message to iOS Webview
            //@ts-ignore
            window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closePop");
        if (isFromRnSDk) {
            window?.open("closePop", "_parent");
            // @ts-ignore
            window?.ReactNativeWebView?.postMessage("closePop");
            window?.top?.postMessage("closePop");
        }
    }
};
export const digiLockerModeInit = async (action, _datastore, { network, navigate, navigateWithClear, removeWidgets, setDatastore, showPopup, hidePopup }) => {
    const user = await SharedPropsService.getUser();
    let applicationId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
        loading: true
    });
    if (Platform.OS === "web" && !isMobile()) {
        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
            showInProgressCard: true,
            failedCard: false,
            successCard: false,
            counter: Math.random()
        });
    }
    else {
        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
            showInProgressCard: false,
            failedCard: false,
            successCard: false,
            counter: Math.random()
        });
    }
    const digiLockerModeInitResponse = await network.post(`${api.kycDigiLockerMode}${applicationId}`, {}, { headers: await getAppHeader() });
    let bajajDigioWindowObj;
    let pollInterval;
    let tempPop;
    if (digiLockerModeInitResponse && digiLockerModeInitResponse.status === 200) {
        const requestUrl = digiLockerModeInitResponse?.data?.stepResponseObject?.uri;
        const urlTATA = await network.get(`${api.getTATAKYCURL}${applicationId}`, {
            headers: await getAppHeader()
        });
        const allowedOrigins = [
            'https://app.staging.voltmoney.in',
            'https://test.staging.voltmoney.in',
            'https://qa.staging.voltmoney.in',
            'https://app.voltmoney.in'
        ];
        //handle for web
        if (Platform.OS === 'web' && requestUrl) {
            const params = getParameters(window.location.href);
            const isFromiOSSDK = params?.isFromiOSSdk;
            const isFronRnSdk = params?.isFromRnSdk;
            console.warn("PARAMS ARE", params);
            console.warn("isFromRnSdk", isFronRnSdk);
            if (isFronRnSdk || params.platform === "ZYPE" || params.platform === "PHONEPE" /* AppPlatform.PHONEPE */) {
                if (params.platform === "PHONEPE" /* AppPlatform.PHONEPE */) {
                    tempPop = window.open(urlTATA?.data?.stepResponseObject?.uri, '_blank', 'width=800,height=600');
                }
                else {
                    tempPop = window.open(urlTATA?.data?.stepResponseObject?.uri, '_parent', 'width=800,height=600');
                }
                window.addEventListener('message', async function (event) {
                    if (event?.data === "stopLoader") {
                        console.warn("EVENT RECEIVED FOR STOPPING LAODER");
                        clearInterval(pollInterval);
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            showAddressMismatchCard: false,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application",
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                    }
                    console.log('Message received from React Native (window):', event.data);
                    // Do something with the message
                });
            }
            else {
                if (isFromiOSSDK)
                    tempPop = window.open(urlTATA?.data?.stepResponseObject?.uri, '_parent', 'width=800,height=600');
                else {
                    tempPop = window.open(urlTATA?.data?.stepResponseObject?.uri, 'PopupWindowName', 'width=800,height=600');
                }
                tempPop?.addEventListener('message', function (event) {
                    // Ensure the message is coming from an allowed origin
                    if (allowedOrigins.includes(event.origin)) {
                        // Handle the received message
                        console.log('Received message:', event.data, event);
                        if (event) {
                            tempPop.location.href = urlTATA?.data?.stepResponseObject?.uri;
                        }
                    }
                    else {
                        console.warn('Received message from unknown origin:', event.origin);
                    }
                }, false);
            }
        }
        else if (Platform.OS !== 'web') {
            const urlTATA = await network.get(`${api.getTATAKYCURL}${applicationId}`, {
                headers: await getAppHeader()
            });
            navigate(ROUTE.DIGIO_MODAL, {
                kycTATA: true,
                webUrl: urlTATA?.data?.stepResponseObject?.uri
            });
            removeWidgets(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, [
                { id: 'title', type: WIDGET.TEXT },
                { id: 'spaceSubTitle', type: WIDGET.SPACE },
                { id: 'subTitle', type: WIDGET.STACK },
                {
                    id: 'spaceSecondarySubTitle',
                    type: WIDGET.SPACE,
                },
                { id: 'informationCard', type: WIDGET.STACK },
                {
                    id: 'stackBottom',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ]);
        }
        const checkDigioStatus = async () => {
            if (Platform.OS !== "web") {
                const digioStatusResponse = await network.get(`${api.kycDigiLockerModeStatus}${applicationId}`, {
                    headers: await getAppHeader(),
                }, async () => {
                    return;
                }, { disableDefault: true });
                if (digioStatusResponse?.status === 200) {
                    const digioStatus = digioStatusResponse?.data?.stepResponseObject?.status;
                    if (bajajDigioWindowObj?.closed && (digioStatus !== DigioKycStatus.COMPLETED && digioStatus !== DigioKycStatus.FAILED && digioStatus !== DigioKycStatus.EXPIRED)) {
                        clearInterval(pollInterval);
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application",
                            failedButtonTitle: 'Try again',
                            loading: true
                        });
                        sendPostMessageToRnWebview();
                    }
                    else if (digioStatus === DigioKycStatus.COMPLETED) {
                        clearInterval(pollInterval);
                        currentStepId = digioStatusResponse?.data?.updatedApplicationObj?.currentStepId;
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showInProgressCard: false,
                            showSuccessModal: true,
                            showFailedModal: false,
                            successTitle: 'Aadhaar and PAN verified successfully',
                            successSubTitle: ' ',
                            successButtonTitle: 'Continue',
                            loading: true
                        });
                        sendPostMessageToRnWebview();
                    }
                    else if (digioStatus === DigioKycStatus.EXPIRED
                        || digioStatus === DigioKycStatus.FAILED) {
                        clearInterval(pollInterval);
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: 'Something went wrong',
                            failedSubTitle: "",
                            failedButtonTitle: 'Try again',
                            loading: true
                        });
                        sendPostMessageToRnWebview();
                    }
                }
                else {
                    clearInterval(pollInterval);
                    if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.ADDRESS_MISMATCH) {
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showAddressMismatchCard: true,
                            showFailedModal: false,
                            showSuccessModal: false
                        });
                        sendPostMessageToRnWebview();
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.USER_AUTH_CANCELLED) {
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application",
                            failedButtonTitle: 'Try again',
                            loading: true
                        });
                        sendPostMessageToRnWebview();
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.USER_CONSENT_DENIED) {
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application",
                            failedButtonTitle: 'Try again',
                            loading: true
                        });
                        sendPostMessageToRnWebview();
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.KYC_NOT_INITIATED) {
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application",
                            failedButtonTitle: 'Try again',
                            loading: true
                        });
                        sendPostMessageToRnWebview();
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.INSUFFICIENT_SCOPE) {
                        await navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application",
                            failedButtonTitle: 'Try again',
                            loading: true
                        });
                        sendPostMessageToRnWebview();
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO) {
                        await navigateWithClear(ROUTE.NAME_MISMATCH, {
                            shouldCallMismatchApi: true,
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: false,
                        });
                        sendPostMessageToRnWebview();
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.AGE_BELOW_LIMIT) {
                        navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: 'Minimum age requirement not met',
                            failedSubTitle: `${digioStatusResponse?.response?.data?.message}`,
                            failedButtonTitle: 'Ok, got it.',
                            loading: true
                        });
                        sendPostMessageToRnWebview();
                        return;
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.AGE_ABOVE_LIMIT) {
                        navigateWithClear(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedTitle: "Age eligibility criteria not met",
                            failedSubTitle: `${digioStatusResponse?.response?.data?.message}`,
                            failedButtonTitle: 'Ok, got it.',
                            loading: true
                        });
                        sendPostMessageToRnWebview();
                        return;
                    }
                }
            }
            else if (Platform.OS === "web") {
                const digioStatusResponse = await network.get(`${api.kycDigiLockerModeStatus}${applicationId}`, {
                    headers: await getAppHeader(),
                    handleFromMF: true
                });
                // @ts-ignore
                // window.addEventListener('message', async function(event) {
                //
                //     console.log('Message received from React Native (window):', event.data);
                //     // Do something with the message
                // });
                let params;
                if (digioStatusResponse?.status === 200) {
                    const digioStatus = digioStatusResponse?.data?.stepResponseObject?.status;
                    if (Platform.OS === 'web')
                        params = getParameters(window.location.href);
                    if (tempPop?.closed && (digioStatus !== DigioKycStatus.COMPLETED && digioStatus !== DigioKycStatus.FAILED && digioStatus !== DigioKycStatus.EXPIRED && params.platform !== "PHONEPE" /* AppPlatform.PHONEPE */)) {
                        clearInterval(pollInterval);
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application",
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                        sendPostMessageToRnWebview();
                    }
                    else if (digioStatus === DigioKycStatus.COMPLETED) {
                        tempPop?.close();
                        clearInterval(pollInterval);
                        currentStepId = digioStatusResponse?.data?.updatedApplicationObj?.currentStepId;
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: true,
                            failedCard: false,
                            shouldCallMismatchApi: false,
                            successTitle: 'Aadhaar and PAN verified successfully',
                            successSubTitle: ' ',
                            successButtonTitle: 'Continue',
                            counter: Math.random()
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                        sendPostMessageToRnWebview();
                    }
                    else if (digioStatus === DigioKycStatus.EXPIRED
                        || digioStatus === DigioKycStatus.FAILED) {
                        tempPop?.close();
                        clearInterval(pollInterval);
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            failedTitle: 'Something went wrong',
                            failedSubTitle: ' ',
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            loading: false,
                        });
                        sendPostMessageToRnWebview();
                    }
                }
                else {
                    tempPop?.close();
                    clearInterval(pollInterval);
                    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                        loading: false,
                    });
                    if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.USER_AUTH_CANCELLED) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            failedTitle: 'KYC Verification cancelled',
                            failedSubTitle: "KYC verification is required for the completion of your loan application.",
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.USER_CONSENT_DENIED) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            failedTitle: 'Verification failed!',
                            failedSubTitle: "Please allow consent to complete your application.",
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.KYC_NOT_INITIATED) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            failedTitle: 'Verification failed!',
                            failedSubTitle: "Please allow consent to complete your application.",
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.INSUFFICIENT_SCOPE) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, "renderDigioCard", {
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: true,
                            failedTitle: 'Verification failed!',
                            failedSubTitle: "Please allow consent to complete your application.",
                            failedButtonTitle: 'Try again',
                            counter: Math.random()
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO) {
                        await navigate(ROUTE.NAME_MISMATCH, {
                            shouldCallMismatchApi: true,
                            showInProgressCard: false,
                            successCard: false,
                            failedCard: false,
                        });
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.AGE_BELOW_LIMIT) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedCard: true,
                            failedTitle: "Minimum age requirement not met",
                            failedSubTitle: `${digioStatusResponse?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it.",
                            counter: Math.random()
                        });
                        return;
                    }
                    else if (digioStatusResponse.response.data.voltErrorCode === VOLT_ERROR_CODE.AGE_ABOVE_LIMIT) {
                        await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
                            showInProgressCard: false,
                            showSuccessModal: false,
                            showFailedModal: true,
                            failedCard: true,
                            failedTitle: "Age eligibility criteria not met",
                            failedSubTitle: `${digioStatusResponse?.response?.data?.message}`,
                            failedButtonTitle: "Ok, got it.",
                            counter: Math.random()
                        });
                        return;
                    }
                    sendPostMessageToRnWebview();
                }
            }
        };
        pollInterval = setInterval(async () => {
            await checkDigioStatus();
        }, 3000);
        await SharedPropsService.setPollarInterval(pollInterval);
    }
};
export const closeLoaderAction = async (action, datastore, { setDatastore }) => {
    await setDatastore(ROUTE.KYC_DOCUMENTS_DIGIO_BASE, 'renderDigioCard', {
        loading: false,
    });
};
export const clearPollarAction = async (action, datastore, { setDatastore }) => {
    clearInterval(pollInterval);
};
